const observer = new MutationObserver(function(mutations_list) {
  if (mutations_list == null) return
  mutations_list.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(added_node) {
      if(added_node.classList.contains('cbb-also-bought-container')) {
        $('.cbb-also-bought-title').replaceWith('<h3>NEW HOT POT GOURMET</h3><p>Everything you need to elevate your Hot Pot Experience at home.<br>Choose Your Favorite Soup Base together with ready-to-dip Beef, Pork, Seafood, Chicken and Fresh Vegetables</p>')
        observer.disconnect();
      }
    });
  });
});

function updateCartUpsellProgress(total_price) {
  var max_price = $('.cws-upsell-cart .progress-bar').data('max-price')
  var progress = total_price / max_price * 100
  if (progress < 100) {
    $('.cws-upsell-cart .progress-bar span').width(progress.toString()+'%')
  } else {
    $('.cws-upsell-cart .progress-bar span').width('100%')
  }
}

function observeAlsoBoughtLoading() {
  var upsell_cart = document.querySelector(".cws-upsell-cart")
  if (upsell_cart) {
    observer.observe(document.querySelector(".cws-upsell-cart"), { subtree: false, childList: true });
  }
}


function unavailableDates(date) {
  var disabledDates = ["2022-02-27"];
  var showDate = jQuery.datepicker.formatDate('yyyy-mm-dd', date);
  console.log("Current date: ", date)
  return [ disabledDates.indexOf(showDate) == -1 ]
}

function disableDeliveryDates() {
  jQuery(".identixweb-order-delivery").on("click", ".order-calendar-button-click", function() {
    //jQuery(".uiDeliveryCalendar").datepicker('option','maxDate', '+14d');
    jQuery(".uiDeliveryCalendar").datepicker('option','beforeShowDay', unavailableDates);
  });
}

window.addEventListener('DOMContentLoaded', (event) => {
  $.getJSON('/cart.js', function (cart) {
    if (cart) {
      updateCartUpsellProgress(cart.total_price)
      //disableDeliveryDates();
      //observeAlsoBoughtLoading();
    }
  });

});